// extracted by mini-css-extract-plugin
export default {"fabButton":"BackButton_fabButton__X0i1f"};